import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NavController } from '@ionic/angular';
import { PortabilityKeysService } from '@wlp/ui-bs-pix';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { LoadingService } from 'src/app/core/layout/services/loading.service';

// import { AuthService } from './../../../../../../../../core/auth/auth-service';
// import { UserProfile } from './../../../../../../../../core/dto/user-profile';

import { UserInfoProfile, UserInfoService } from '@wlp/ui-bs-login';

@Component({
  selector: 'app-portability',
  templateUrl: './portability.page.html',
  styleUrls: ['./portability.page.scss'],
})
export class PortabilityPage implements OnInit {

  backgroundImage: string;
  userProfile: UserInfoProfile;
  listKeys: [];
  dataRegister: any;
  cdr: any;
  cpfCnpj: any;
  email: any;
  phone: any;
  virtualAdrress: any;
  listObjectCards: { path: any; type: string; cardLabel: string; inputLabel: string }[];

  stepOne: boolean;
  stepTwo: boolean;
  formPortabilityKey: FormGroup;
  param: any;
  wlName: string;

  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;

  constructor(
    private layoutConfigService: LayoutConfigService,
    private navController: NavController,
    protected authService: UserInfoService,
    private load: LoadingService,
    private portabilityService: PortabilityKeysService,
    private translate: UiBsTranslateService
  ) {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);

    this.backgroundImage = this.layoutConfigService.getConfig('wlTheme.header.background.image');
    this.wlName = this.layoutConfigService.getConfig('wlTheme.wlName');

    this.dataRegister = new Date();
  }

  async ngOnInit() {
    this.stepOne = true;
    this.stepTwo = false;

    this.formPortabilityKey = this.portabilityService.getFormformPortabilityKey();

    this.loadUser();

    this.cpfCnpj = this.layoutConfigService.getImagesPages('cpf-cnpj-pix');
    this.email = this.layoutConfigService.getImagesPages('email-pix');
    this.phone = this.layoutConfigService.getImagesPages('phone-pix');
    this.virtualAdrress = this.layoutConfigService.getImagesPages('virtual-address-pix');

    this.listObjectCards = [
      {
        path: this.cpfCnpj.path,
        type: 'cpfCnpj',
        cardLabel: 'PIX.PIX_REGISTER_KEY.CARDS_LABELS.RG_CNPJ',
        inputLabel: 'PIX.PIX_REGISTER_KEY.INPUT_LABELS.RG_CNPJ',
      },
      {
        path: this.phone.path,
        type: 'phone',
        cardLabel: 'PIX.PIX_REGISTER_KEY.CARDS_LABELS.PHONE',
        inputLabel: 'PIX.PIX_REGISTER_KEY.INPUT_LABELS.PHONE',
      },
      {
        path: this.email.path,
        type: 'email',
        cardLabel: 'PIX.PIX_REGISTER_KEY.CARDS_LABELS.EMAIL',
        inputLabel: 'PIX.PIX_REGISTER_KEY.INPUT_LABELS.EMAIL',
      },
    ];
  }

  loadUser() {
    this.authService.getInfoProfile().then(
      (res) => {
        this.userProfile = res;
        if (this.userProfile) {
        }
      },
      () => {
        this.load.hide();
        this.cdr.detectChanges();
      }
    );
  }

  keyTypeReturn(event) {
    this.param = { keyTextType: event.typeTextKey, wlName: this.wlName };
    this.stepOne = false;
    this.stepTwo = true;
  }

  goToRegisterKey() {
    this.navController.navigateRoot(['app/pix/register-key-pix']);
  }

  continue() {
    this.portabilityService.setFormBehaviorList(this.formPortabilityKey);
    this.navController.navigateRoot(['app/pix/code-validation']);
  }
}
